export default __webpack_public_path__ + "4cb93975347f371d99a04cd6e770d1d8.png";